// @ts-check
/** @type {InhalationAgent[]} */
export const inhalationAgentsArray = [
  {
    id: '7806',
    name: 'Oxygen',
    color: '#00B154',
    unit: 'L/min',
    step: 0.5,
    sortOrder: 0,
    max: 25,
  },
  {
    id: '7486',
    name: 'Nitrous Oxide',
    color: '#437AF8',
    unit: 'L/min',
    step: 0.5,
    sortOrder: 1,
    max: 25,
  },
  {
    id: '36453',
    name: 'Sevoflurane',
    color: '#E6C90F',
    unit: '%',
    step: 0.1,
    max: 8,
    isAA: true,
    sortOrder: 2,
  },
  {
    id: '27340',
    name: 'Desflurane',
    color: '#00A0E1',
    unit: '%',
    step: 0.1,
    max: 18,
    isAA: true,
    sortOrder: 3,
  },
  {
    id: '6026',
    name: 'Isoflurane',
    color: '#A93F9A',
    unit: '%',
    step: 0.1,
    max: 5,
    isAA: true,
    sortOrder: 4,
  },
  {
    id: '411',
    name: 'Medical Air',
    color: '#FFDF00,#000',
    unit: 'L/min',
    step: 0.5,
    max: 25,
    deepGaOnly: true,
    sortOrder: 5,
  },
]

/** @type {Record<string, InhalationAgent & { sortOrder: number }>} */
export const inhalationAgentsById = inhalationAgentsArray.reduce(
  (acc, agent) => {
    acc[agent.id] = agent
    return acc
  },
  {}
)
